"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.classMetadataReflectKey = void 0;
exports.classMetadataReflectKey = '@inversifyjs/core/classMetadataReflectKey';
//# sourceMappingURL=classMetadataReflectKey.js.map